import type {ItemComponentProps } from 'core/components/Elements/DropDown/DropDown';
import { getDropdownItemForCommand } from 'core/components/Elements/DropDown/DropDown';
import React from 'react';

function ItemGroupMenu({
  item: { commands }, buttonRef, onClose,
}: ItemComponentProps) {
  return (
    <div data-testid="groupmenu">
      {commands.map((item) => (
        getDropdownItemForCommand(item, false, buttonRef, onClose, () => {}, () => {})
      ))}
    </div>
  );
}

export default ItemGroupMenu;
